import RefreshIcon from "@mui/icons-material/Refresh";
import { Alert, Box, CircularProgress, IconButton } from "@mui/material";
import React, { useEffect } from "react";
import { Entity, UpdateEntityRequest } from "../../../types/model/entity/Entity";
import EntityInfo from "../EntityInfo";
import { useTranslation } from "react-i18next";

interface GeneralTabProps {
  entityData?: Entity;
  onUpdate: (values: UpdateEntityRequest) => Promise<any>;
  isPending?: boolean;
  isUpdating?: boolean;
  isError?: boolean;
  error?: any;
  handleError?: any;
  refetch?: any;
}

const GeneralTab: React.FC<GeneralTabProps> = ({
  entityData,
  onUpdate,
  isPending,
  isUpdating,
  isError,
  error,
  handleError,
  refetch,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!handleError) return;
    if (isError) handleError(error);
  }, [isError]);

  if (isPending && !entityData) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError && !entityData) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Alert
          severity="error"
          action={
            <IconButton onClick={() => refetch?.()} color="inherit" size="small">
              <RefreshIcon />
            </IconButton>
          }
        >
          {t("generic.errors.something-went-wrong")}
        </Alert>
      </Box>
    );
  }

  if (!entityData) return null;

  return (
    <EntityInfo
      entityData={entityData}
      onSubmit={onUpdate}
      isUpdating={isUpdating}
    />
  );
};

export default GeneralTab;